import { Injectable } from '@angular/core'
import { environment } from '../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import moment from 'moment-mini'
import { PushNotificationTokenPayload } from './settings/interfaces'

type PushNotificationTokenResponse = {
  createdAt: moment.Moment
  fcmToken: string
  id: number
  memberId: number
  modifiedAt: moment.Moment
}

@Injectable()
export class PushNotificationService {
  constructor(private http: HttpClient) {}

  public postPushNotificationToken(
    pushNotificationToken: string
  ): Observable<PushNotificationTokenResponse> {
    const endpointUrl: string = `${environment.backendApiUrl}/push-notification-tokens`

    const payload: PushNotificationTokenPayload = {
      token: pushNotificationToken,
      tokenType: 'fcm'
    }

    return this.http.post<PushNotificationTokenResponse>(endpointUrl, payload)
  }
}
